<template>
  <div>
    <div class="box-type">
      <div class="box1">
        <div :class="{ sel: currTyep === '自选' }" @click="typeChange('自选')">
          自选
        </div>
        <div
          :class="{ sel: currTyep === 'USDT支付' }"
          @click="typeChange('USDT支付')"
        >
          USDT支付
        </div>
        <div
          :class="{ sel: currTyep === 'RWA支付' }"
          @click="typeChange('RWA支付')"
        >
          RWA支付
        </div>
      </div>
      <div class="box2">
        <p>更多</p>
        <i class="el-icon-arrow-down" />
      </div>
    </div>
    <div class="search-list-box">
      <div class="pauto12">
        <el-input
          placeholder="搜索币种"
          suffix-icon="el-icon-search"
          v-model="inputValue"
        />
      </div>
      <div class="table-head-box">
        <div>币种</div>
        <div class="table-head-end-box">
          <div class="sort-item-box">
            最新价
            <div class="sort-box">
              <i style="margin-top: 2px" class="el-icon-caret-top"></i>
              <i style="margin-top: -2px" class="el-icon-caret-bottom"></i>
            </div>
          </div>
          <div class="sort-item-box">
            涨跌幅
            <div class="sort-box">
              <i style="margin-top: 2px" class="el-icon-caret-top"></i>
              <i style="margin-top: -2px" class="el-icon-caret-bottom"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="table-body-box" v-for="(value, index) in 2" :key="index">
        <div class="c-flex-align-center">DIMD</div>
        <div class="table-head-end-box">
          <div class="sort-item-box2">
            <p>3,195.2500 USDT</p>
            <p class="p1">￥23005.8</p>
          </div>
          <div :class="index == 1 ? 'p2':'p3'" class="sort-item-box">
            -2.00%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currTyep: "自选",
      inputValue: "",
    };
  },
  mounted() {},
  methods: {
    typeChange(val) {
      this.currTyep = val;
    },
  },
};
</script>

<style lang="less" scoped>
.text-end {
  align-items: flex-end;
}
.box-type {
  display: flex;
  padding: 12px;
  align-items: center;
  background: #ffffff;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  border-radius: 8px 8px 8px 8px;
  justify-content: space-between;
  .box1 {
    gap: 28px;
    display: flex;
    .sel {
      font-weight: 800;
      font-size: 16px;
      color: #4063ff;
    }
    .sel::before {
      content: "";
      position: absolute;
      display: block;
      left: 0;
      width: 100%;
      bottom: -12px;
      border-bottom: 2px solid #4063ff;
    }
    div {
      cursor: pointer;
      position: relative;
    }
  }
  .box2 {
    display: flex;
    align-items: center;
    p {
      cursor: pointer;
    }
    i {
      font-size: 12px;
      color: #4063ff;
    }
  }
}
.search-list-box {
  margin-top: 12px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  .table-head-box {
    display: flex;
    margin-bottom: 12px;
    padding: 0px 12px 12px 12px;
    justify-content: space-between;
    border-bottom: 1px solid #e2e3e3;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    .table-head-end-box {
      gap: 40px;
      display: flex;
      justify-content: space-between;
      .sort-item-box {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .sort-box {
        display: flex;
        font-size: 12px;
        margin-top: -4px;
        flex-direction: column;
        .sel {
          color: #4063ff;
        }
        i {
          cursor: pointer;
          color: #d6d8db;
          margin-bottom: -4px;
        }
      }
    }
  }
  .table-body-box {
    display: flex;
    padding: 0px 12px 12px 12px;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    .table-head-end-box {
      gap: 40px;
      display: flex;
      justify-content: space-between;
      .sort-item-box2 {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      .sort-item-box {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .sort-box {
        display: flex;
        font-size: 12px;
        margin-top: -4px;
        flex-direction: column;
      }
      .p2 {
        color: #f6465d;
      }
      .p3 {
        color: #52c18e;
      }
      .p1 {
        font-size: 14px;
      }
    }
  }
}
</style>
